import { render, staticRenderFns } from "./stickyWrap.vue?vue&type=template&id=77a5cdeb&lang=pug&"
import script from "./stickyWrap.vue?vue&type=script&lang=js&"
export * from "./stickyWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports